let _ = t => t,
  _t;
import MediaPlayerHead from './MediaPlayerHead';
import { memo, useContext } from 'react';
import styledWithTheme from 'foundations-theming/utils';
import { MediaElementContext } from '../../context/MediaElementContext';
import { MediaPlayerBar } from './MediaPlayerBar';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLineProgress = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
`));
const __MediaPlayerProgressIndicator = ({
  showPlayerHead
}) => {
  const {
    mediaProgressBarRef
  } = useContext(MediaElementContext);
  return /*#__PURE__*/_jsxs(StyledLineProgress, {
    ref: mediaProgressBarRef,
    children: [/*#__PURE__*/_jsx(MediaPlayerBar, {
      "data-test-id": "mediaProgressBar-progressLine",
      backgroundColor: MEDIA_PLAYER_COLORS.ACTIVE_STATUS_FILL,
      inlineSize: "100%"
    }), /*#__PURE__*/_jsx(MediaPlayerHead, {
      visible: showPlayerHead
    })]
  });
};
export const MediaPlayerProgressIndicator = /*#__PURE__*/memo(__MediaPlayerProgressIndicator);